import React, {Component} from 'react'
import {NavBar,InputItem,Toast} from 'antd-mobile';
import {getPhoneCode} from '../../../service/loginService';
import './style.less'
export default class ResetPwd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phone: '',
            check:true
        };
    }

     //监听用户输入手机号的位数判断按钮的颜色
     phoneChange = (value) => {
        this.setState({phone: value});
        if(value.replace(/\s/ig, '').length == 11){
            this.setState({check: false});
        }else if(value.replace(/\s/ig, '').length < 11){
            this.setState({check: true});
        }

    };
    getCode =() =>{
        let params = {
            "type": 1,
            "source":6,
            "phone":this.state.phone
          
        };
        let parr={
            data:params
        }
        getPhoneCode(parr)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    Toast.info("验证码已发送至手机！",2,() => this.props.history.push('/getCode',{phone:this.state.phone,status:0,}))
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
            }).catch(function (error) {
            console.log(error);
        });
    }
    render() {
        return (
            <div className="resetPwd">
                <NavBar
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui"> </i>}
                    onLeftClick={() => this.props.history.goBack()}
                >
                </NavBar>
                <div className="regInfo">
                    <div className="identity">验证身份</div>
                    <div className="checkMobile">确认工号绑定的手机号码</div>
                    <div className="inputMobile">请输入绑定手机号</div>
                <InputItem
                    type="text"
                    maxLength={20}
                    placeholder="手机号"
                    value={this.state.phone}
                    onChange={this.phoneChange}
                />
                <div className="submitBox">
                    <button disabled={this.state.check} onClick={() => this.getCode()}>获取验证码</button>
                </div>
            </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Login/ResetPwd/index.js